import Home from "@/pages/Home/Home";
import FeedPage from "@/pages/FeedPage/FeedPage";
import MultiCamPage from "@/pages/MultiCamPage/MultiCamPage";
import { NotFound } from "@/pages/NotFound";
import SurfDashboard from "@/components/SurfDashboard/SurfDashboard";
import Welcome from "@/pages/Welcome/Welcome";
import PrivacyPolicy from "@/pages/Legal/PrivacyPolicy";
import TermsOfService from "@/pages/Legal/TermsOfService";
import Accuracy from "@/pages/Accuracy/Accuracy";
import EngagementAuthPrompt from "@/components/Auth/EngagementAuthPrompt";
import RouteTracker from "@/components/RouteTracker";
import { flaglerLandingPages } from "@/lib/flaglerLandings";
import { seoPages } from "@/lib/seoPages";
import { spotPages } from "@/lib/spotPages";
import FlaglerLandingPage from "@/pages/Flagler/FlaglerLandingPage";
import { usePageView } from "@/hooks/usePageView";
import { lazy, ReactNode, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const SurfSpots = lazy(() => import("@/pages/SurfSpots/SurfSpots"));

// Pages with automatic redirects call usePageView themselves once settled.
function TrackedPage({ children }: { children: ReactNode }) {
  usePageView();
  return <>{children}</>;
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <RouteTracker>
        <EngagementAuthPrompt />
        <Routes>
          <Route path="/welcome" element={<Welcome />} />
          <Route
            path="/privacy"
            element={
              <TrackedPage>
                <PrivacyPolicy />
              </TrackedPage>
            }
          />
          <Route
            path="/terms"
            element={
              <TrackedPage>
                <TermsOfService />
              </TrackedPage>
            }
          />
          <Route path="/" element={<Home />} />
          {seoPages.map((page) => (
            <Route
              key={page.path}
              path={page.path}
              element={
                <Suspense fallback={null}>
                  <TrackedPage>
                    <SurfSpots page={page} />
                  </TrackedPage>
                </Suspense>
              }
            />
          ))}
          {spotPages.map((page) => (
            <Route key={page.path} path={page.path} element={<Home spotPage={page} />} />
          ))}
          {flaglerLandingPages
            .filter((page) => page.topic !== "report")
            .map((page) => (
              <Route
                key={page.path}
                path={page.path}
                element={
                  <TrackedPage>
                    <FlaglerLandingPage path={page.path} />
                  </TrackedPage>
                }
              />
            ))}
          <Route path="/spot/:regionId" element={<Home />} />
          <Route path="/spot/:regionId/:cameraId" element={<Home />} />
          <Route
            path="/feed"
            element={
              <TrackedPage>
                <FeedPage />
              </TrackedPage>
            }
          />
          <Route path="/multicam" element={<MultiCamPage />} />
          <Route path="/multicam/:regionId" element={<MultiCamPage />} />
          <Route
            path="/forecast"
            element={
              <TrackedPage>
                <SurfDashboard />
              </TrackedPage>
            }
          />
          <Route
            path="/accuracy"
            element={
              <TrackedPage>
                <Accuracy />
              </TrackedPage>
            }
          />
          <Route
            path="*"
            element={
              <TrackedPage>
                <NotFound />
              </TrackedPage>
            }
          />
        </Routes>
      </RouteTracker>
    </BrowserRouter>
  );
}
